import { Injectable } from '@angular/core';
import { getAuth } from 'firebase/auth';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AffiliateAttributionService {
  async claimRegistration(accountId: string | null): Promise<void> {
    const token = await getAuth().currentUser?.getIdToken(true);
    if (!token) {
      return;
    }

    const response = await fetch(environment.affiliateRegistrationAttributionUrl, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ accountId })
    });

    if (!response.ok && response.status !== 204) {
      throw new Error('Unable to claim affiliate registration attribution.');
    }
  }
}
